/* 🤖 this file was generated by svg-to-ts */
export const iconEnkryptwallet: {
  name: 'enkryptwallet';
  data: string;
} = {
  name: 'enkryptwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m10.71 16.59c0 1.47-1.19 2.66-2.65 2.66h-8.6c-1.47 0-2.66-1.19-2.66-2.66v-.71c0-1.47 1.19-2.66 2.66-2.66h8.6a2.65 2.65 0 0 1 2.65 2.66zm0-8.2a3.05 3.05 0 0 1-3.05 3.05h-8.38c-2.35 0-4.25 1.9-4.25 4.25v1.08c0 2.35 1.9 4.25 4.25 4.25h8.38a3.05 3.05 0 0 1 3.05 3.05v3.13H8.88c-2.35 0-4.25-1.9-4.25-4.25V9.37c0-2.35 1.9-4.25 4.25-4.25h17.83z"/></svg>`,
};
